import { useState } from "react";
import AtividadeItem from "./AtividadeItem";
import LogoAdoraTeam from "./LogoAdoraTeam";
import { GOLD, BLUE, TEMAS } from "../constants/temas";

function getMsgs(perfil, saudacao) {
    const funcao = perfil?.funcao || "BANDA";
    const msgs = {
        BANDA:     [`${saudacao}! Pronto para adorar? 🎸`, "Que sua música toque corações 🎵", "Afia as cordas e vai! 🔥"],
        Soprano:   [`${saudacao}, soprano! 👼`, "Que sua voz soe linda hoje ✨"],
        Contralto: [`${saudacao}! Contralto na área 💜`, "Sua voz é o alicerce do louvor 🙌"],
        Tenor:     [`${saudacao}, tenor! 🎤`, "Que seu alcance inspire hoje 🔥"],
        Barítono:  [`${saudacao}! Barítono firme 💪`, "Sua voz sustenta tudo 🎵"],
    };
    return msgs[funcao] || msgs["BANDA"];
}

export default function Home({ musicas, abrirMusica, setTab, perfil, proximoEvento, atividades, setAtividades, atualizarFoto, tema }) {
    const T = TEMAS[tema];
    const { nome, funcao, msgIdx = 0 } = perfil || {};
    const hora = new Date().getHours();
    const saudacao = hora < 12 ? "Bom dia" : hora < 18 ? "Boa tarde" : "Boa noite";
    const msgs = getMsgs(perfil, saudacao);
    const msgAtual = msgs[msgIdx % msgs.length];

    const selecionarFoto = e => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = ev => atualizarFoto(ev.target.result);
        reader.readAsDataURL(file);
    };

    const cards = [
        { icon: "📅", label: "Escala",  sub: "Próximos eventos",        acao: () => setTab("escala"),  destaque: true },
        { icon: "🎵", label: "Músicas", sub: "Cifras e repertório",      acao: () => setTab("musicas"), destaque: false },
        { icon: "👥", label: "Equipe",  sub: "Membros do ministério",    acao: () => setTab("rede"),    destaque: false },
        { icon: "💬", label: "Chat",    sub: "Falar com a equipe",       acao: () => setTab("chat"),    destaque: false },
    ];

    return (
        <div style={{ padding: "12px 16px 88px" }}>

            {/* ── Header do perfil ──────────────────────────────────────────── */}
            <div style={{
                background: `linear-gradient(135deg, ${BLUE}, #1a2540)`,
                borderRadius: 20, padding: "14px 16px",
                color: "white", marginBottom: 16,
                border: `1px solid ${GOLD}22`,
                boxShadow: `0 4px 24px ${GOLD}12`,
            }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: proximoEvento ? 10 : 0 }}>
                    {/* Avatar */}
                    <div
                        style={{ position: "relative", flexShrink: 0, cursor: "pointer" }}
                        onClick={() => document.getElementById("fotoHomeInput").click()}
                    >
                        <div style={{
                            width: 52, height: 52, borderRadius: "50%",
                            overflow: "hidden", border: `2px solid ${GOLD}`,
                            boxShadow: `0 0 12px ${GOLD}44`,
                        }}>
                            {perfil?.foto
                                ? <img src={perfil.foto} alt="perfil" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                : <div style={{ width: "100%", height: "100%", background: `${GOLD}22`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🎵</div>
                            }
                        </div>
                        <div style={{
                            position: "absolute", bottom: 0, right: 0,
                            background: GOLD, borderRadius: "50%",
                            width: 16, height: 16,
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: 9,
                        }}>📷</div>
                    </div>
                    <input id="fotoHomeInput" type="file" accept="image/*" style={{ display: "none" }} onChange={selecionarFoto} />

                    {/* Info */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>{saudacao} 👋</div>
                        <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: -0.5, lineHeight: 1.2 }}>{nome}</div>
                        <div style={{ fontSize: 11, color: GOLD, marginTop: 1 }}>
                            {funcao === "BANDA" ? "🎸" : "🎤"} {perfil?.instrumento || perfil?.voz || funcao}
                        </div>
                    </div>

                    {/* Mensagem motivacional — bem discreta */}
                    <div style={{ fontSize: 10, color: "rgba(255,255,255,0.35)", fontStyle: "italic", maxWidth: 90, textAlign: "right", lineHeight: 1.4 }}>
                        {msgAtual}
                    </div>
                </div>

                {/* ── Próximo evento — destaque ──────────────────────────── */}
                {proximoEvento && (
                    <div
                        onClick={() => setTab("escala")}
                        style={{
                            background: `${GOLD}20`, borderRadius: 14,
                            padding: "12px 14px",
                            border: `1px solid ${GOLD}55`,
                            boxShadow: `0 2px 12px ${GOLD}18`,
                            cursor: "pointer",
                        }}
                    >
                        <div style={{ fontSize: 10, color: GOLD, fontWeight: 800, textTransform: "uppercase", letterSpacing: 1.2, marginBottom: 4 }}>
                            📅 Próximo evento
                        </div>
                        <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 2 }}>{proximoEvento.titulo}</div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }}>{proximoEvento.dataFormatada}</div>
                            {proximoEvento.setlist?.length > 0 && (
                                <div style={{ fontSize: 11, color: `${GOLD}aa`, background: `${GOLD}18`, borderRadius: 10, padding: "2px 8px" }}>
                                    🎵 {proximoEvento.setlist.length} música{proximoEvento.setlist.length !== 1 ? "s" : ""}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* ── Cards de acesso rápido ──────────────────────────────────── */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
                {cards.map((c, i) => (
                    <button
                        key={i}
                        onClick={c.acao}
                        style={{
                            background: i === 0
                                ? `linear-gradient(135deg, ${GOLD}22, ${GOLD}08)`
                                : T.bgCard,
                            borderRadius: 18,
                            padding: "18px 16px",
                            border: `1px solid ${i === 0 ? GOLD + "55" : T.borda}`,
                            cursor: "pointer",
                            textAlign: "left",
                            transition: "transform 0.15s, box-shadow 0.15s",
                            boxShadow: i === 0 ? `0 4px 16px ${GOLD}18` : "none",
                        }}
                        onMouseOver={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = `0 6px 20px ${GOLD}22`; }}
                        onMouseOut={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = i === 0 ? `0 4px 16px ${GOLD}18` : "none"; }}
                    >
                        <div style={{ fontSize: 28, marginBottom: 8 }}>{c.icon}</div>
                        <div style={{ fontSize: 14, fontWeight: 800, color: i === 0 ? GOLD : T.texto }}>{c.label}</div>
                        <div style={{ fontSize: 11, color: T.textoSecundario, marginTop: 2 }}>{c.sub}</div>
                    </button>
                ))}
            </div>

            {/* ── Músicas recentes (até 3) ────────────────────────────────── */}
            {musicas.length > 0 && (
                <div style={{ background: T.bgCard, borderRadius: 18, padding: "14px 16px", marginBottom: 16, border: `1px solid ${T.borda}` }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 800, color: T.texto }}>🎵 Repertório</div>
                        <button onClick={() => setTab("musicas")} style={{ background: "none", border: "none", color: GOLD, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                            Ver tudo →
                        </button>
                    </div>
                    {musicas.slice(0, 3).map(m => (
                        <button
                            key={m.id}
                            onClick={() => abrirMusica(m)}
                            style={{
                                width: "100%", display: "flex", alignItems: "center", gap: 12,
                                background: T.bgCardSecundario, borderRadius: 12,
                                padding: "10px 12px", marginBottom: 8,
                                border: `1px solid ${T.borda}`, cursor: "pointer", textAlign: "left",
                            }}
                        >
                            <div style={{ width: 36, height: 36, borderRadius: 10, background: `${GOLD}18`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>🎵</div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 700, fontSize: 13, color: T.texto, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.titulo}</div>
                                <div style={{ fontSize: 11, color: T.textoSecundario }}>{m.autor ? `${m.autor} · ` : ""}Tom: {m.tom}</div>
                            </div>
                            <span style={{ color: T.textoSecundario, fontSize: 16 }}>›</span>
                        </button>
                    ))}
                </div>
            )}

            {/* ── Atividades recentes ─────────────────────────────────────── */}
            {atividades?.length > 0 && (
                <div style={{ background: T.bgCard, borderRadius: 18, padding: "14px 16px", border: `1px solid ${T.borda}` }}>
                    <div style={{ fontSize: 13, fontWeight: 800, color: T.texto, marginBottom: 12 }}>⚡ Atividades recentes</div>
                    {atividades.slice(0, 5).map(a => (
                        <AtividadeItem
                            key={a.id}
                            atividade={a}
                            onApagar={() => setAtividades(prev => prev.filter(x => x.id !== a.id))}
                            tema={T}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}